import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const TierDiscountHighlight = styled.span`
  font-weight: 500;
  color: ${theme.color.text.primary};
`;

export const TierRow = styled.div`
  ${theme.typography.labelSmall400};
  color: ${theme.color.text.secondary};
  margin-bottom: 0.25rem;
`;
